export default function () {
    function hideFloating() {
        const floatingActionBar = document.querySelector('.floating-action-bar');
    
        if (!floatingActionBar) {
            return;
        }
    
        window.addEventListener('scroll', function() {
            const fromHero = document.body.offsetTop + 1100;
    
            if (window.pageYOffset > fromHero) {
                floatingActionBar.classList.add('hiding');
            } else {
                floatingActionBar.classList.remove('hiding');
            }
        });
    }
    
    const floatingActionBars = document.getElementsByClassName('floating-action-bar');
    if (floatingActionBars.length > 0) {
        hideFloating();
    }
    
}

/* eslint-disable func-names */
/** STICKY HEADER */
// function hideFloating() {

//     $(window).on('scroll', function() {

//         const fromHero = $('body').offset().top + 1100;
//         if ($(window).scrollTop() > fromHero) {

//             $('.floating-action-bar').addClass('hiding');

//         } else {

//             $('.floating-action-bar').removeClass('hiding');

//         }

//     });

// }

// if (document.getElementsByClassName('floating-action-bar').length > 0) {

//     // never call a function without checking for a 'js- ' class first
//     hideFloating();

// }
